import useMediaBreakpoint, { type MediaBreakpoint } from "./useMediaBreakpoint";

function useMediaBreakpointUp(breakpoint: MediaBreakpoint): boolean {
   return useMediaBreakpoint("up", breakpoint);
}

export default useMediaBreakpointUp;